// extracted by mini-css-extract-plugin
export default {"video-link":"d_j d-flex align-items-center my-2","video-link__link":"d_k ml-2"};